import { downloadCSV } from "ra-core";
import { getConverter } from "./csvConverter";

export const csvExporter = (resource: string, translate: (key: string) => string) => {
  return async (data: any) => {
    const filename = translate(`resources.${resource}.filename`);
    const convert = getConverter(resource, translate);

    const csvString = await convert(data);
    downloadCSV("\ufeff" + csvString, filename);
  };
};
